export enum FileType
{
    PDF='application/pdf',
    Word='application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document ',
    Excel='application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    ImageTypes='image/png,image/bmp,image/jpeg',
    PNG='image/png',
    JPG='image/jpeg',
    JPEG='image/jpeg',
    ZIP='application/zip',
    RAR='application/x-rar-compressed',
    VIDEO='video/webm,video/ogg,video/mp4,video/quicktime,video/x-msvideo,video/x-ms-wmv',
    License='application/octet-stream',
    Xml='text/xml',
    OctetSteam='application/octet-stream',
    Txt='text/plain',
    JSON='application/json',
    PowerPoint='application/vnd.ms-powerpoint,applicationapplication/vnd.openxmlformats-officedocument.presentationml.presentation',
    SVG='image/svg+xml',
    None='',
}